export default "__VITE_ASSET__oh3FdU_t__"